import Service from "./Service";

class BusClaimApiService extends Service {
  constructor() {
    super("api");
  }

  async getTotalCostMax() {
    let result = await this.get(`BusClaims/GetTotalCostMax`, (status, data) => {
      return data;
    });
    return result;
  }

  async getAllowedFileExtension() {
    let result = await this.get(`BusClaims/GetAllowedFileExtension`, (status, data) => {
      return data;
    });
    return result;
  }

  async create(payload) {
    let result = await this.post(`BusClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getAll(payload) {
    let result = await this.post(`BusAdministration/GetClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async checkDuplicate(payload) {
    let result = await this.post(`BusClaims/CheckDuplicate`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getStatisticsInExcel(payload) {
    const url = `BusAdministration/GetStatisticsInExcel`;
    const callBack = (status, data) => data;
    let result = await this.post(url, payload, callBack, "blob");
    return result;
  }

  async getMonthlyClaims(payload) {
    let result = await this.post(`BusAdministration/GetMonthlyClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getMonthlyReimbursement(payload) {
    let result = await this.post(`BusAdministration/GetMonthlyReimbursement`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getDailyClaims(payload) {
    let result = await this.post(`BusAdministration/GetDailyClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getMostCommonTrainNumbers(payload) {
    let result = await this.post(`BusAdministration/GetMostCommonTrainNumbers`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getMostCommonRoutes(payload) {
    let result = await this.post(`BusAdministration/GetMostCommonRoutes`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getTotalReimbursementSEK(payload) {
    let result = await this.post(`BusAdministration/GetTotalReimbursementSEK`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getCurrentApproveClaimJob() {
    let result = await this.get(`BusAdministration/GetCurrentApproveClaimJob`, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaimJobById(id) {
    let result = await this.getWithoutTracker(`BusAdministration/GetApproveClaimJobById?jobId=${id}`, (status, data) => {
      return data;
    });
    return result;
  }

  async approveClaims(payload) {
    let result = await this.post(`BusAdministration/ApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimsForApprove(payload) {
    let result = await this.post(`BusAdministration/getClaimsForApprove`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaims(payload) {
    let result = await this.post(`BusAdministration/GetApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraudReport(payload) {
    let result = await this.post(`BusAdministration/GetFraudReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getSusHistoryDates(payload) {
    let result = await this.post(`BusAdministration/GetSusDates`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getSusHistoryClaims(payload) {
    let result = await this.post(`BusAdministration/GetSusHistoryClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraud() {
    let result = await this.get(`BusAdministration/GetFraud`, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimStatus() {
    let result = await this.get(`BusAdministration/GetClaimStatus`, (status, data) => {
      return data;
    });
    return result;
  }

  async exportSUSFile(payload) {
    let result = await this.post(`BusAdministration/ExportSusFile`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async createSwishPayout(payload) {
    let result = await this.post(`BusAdministration/CreateSwishPayout`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getSwishPayouts(payload) {
    let result = await this.postWithoutTracker(`BusAdministration/GetSwishPayouts`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async exportAccountingReport(payload) {
    let result = await this.post(`BusAdministration/ExportAccountingReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getTicketById(ticketId, ticketType, departureDate) {
    const url = `BusClaims/GetTicketById?ticketId=${ticketId}&ticketType=${ticketType}&departureDate=${departureDate}`;
    const callback = (status, data) => data;
    const timeout = 5000; // 5 seconds
    let result = await this.get(url, callback, timeout);
    return result;
  }
}

export default new BusClaimApiService();
